export default "__VITE_PUBLIC_ASSET__94bd6dcf__"